// extracted by mini-css-extract-plugin
export default {"default":"H6JIKYaVP779OUkbzTY_","success":"DVe_byPI9pzZ5vWOMzrl","error":"X_KenjRfwHcTRmTy0NYx","general":"WfX8lCzFvMBosFGhiqU9"};